import React from 'react';
import './PolicyFortificationismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  POLICY_FORTIFICATIONISM_BUILDING_DISCOUNT_FORTRESS,
  POLICY_FORTIFICATIONISM_FORTRESS_ROUND_END_REPAIRMENT,
  POLICY_FORTIFICATIONISM_MELEE_BONUS
} from "../../../../configs/policy/fortificationism";

const PolicyFortificationismDescription = () => {
  const fortress = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/fortress_light.10136716.png'}
    alt={'Крепость'}
    title={'Крепость'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const buildingDiscount =
    <CoinsStat
      text={POLICY_FORTIFICATIONISM_BUILDING_DISCOUNT_FORTRESS}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const hammer = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/hammer brown.png'}
    alt={'Строительство'}
    title={'Строительство'}
  />;

  const buildingDamage = <img
    className={'policy-description-icon'}
    src={'/img/icons/building_damage.png'}
    alt={'Повреждение'}
    title={'Повреждение'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />

  const buildingDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left'}
    value={POLICY_FORTIFICATIONISM_FORTRESS_ROUND_END_REPAIRMENT}
    icon={buildingDamage}
  />

  const damageBonus = <span className={'text-war'}>
    {`+${POLICY_FORTIFICATIONISM_MELEE_BONUS}`}
  </span>;

  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const damageBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damageBonus}
    icon={<>{damage}{melee}</>}
  />

  return (
    <>
      <div className={'policy-description_line'}>
        {fortress} дешевле {discountElement} на {buildingDiscount}
      </div>
      <div className={'policy-description_line'}>
        и {hammer} мгновенно.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        В конце раунда все {fortress}
      </div>
      <div className={'policy-description_line'}>
        восстанавливают по {buildingDamageValueAndIcon}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        {unit} смежно {fortress} имеет {damageBonusValueAndIcon}.
      </div>
    </>
  );
};

export default PolicyFortificationismDescription;
